import getGeocodeioData from './geocodeio-service';
import getGeoIpData from './geoip-service';
import getCivicData from './google-civic-service';

export default function getRepresentatives(address, showOnlySenators) {
    if (address != null) {
        return getGeocodeioData(null, null, address).then(data =>
            getCivicData(data, showOnlySenators)
        );
    }

    return (
        getGeoIpData()
            .then(data => getGeocodeioData(data.latitude, data.longitude, null))
            // .then(() => getGeocodeioData('37.757078', ' -122.423827'))
            // .then(() => getGeocodeioData('38.95261', ' -77.017898')) // no senators are loaded
            .then(data => getCivicData(data, showOnlySenators))
            .then(data => {
                return new Promise(resolve => {
                    if (data.photoUrl == null) return resolve(data);

                    const imagePreload = new Image();
                    imagePreload.src = data.photoUrl;
                    imagePreload.onload = () => resolve(data);
                });
            })
    );
}



// WEBPACK FOOTER //
// ./src/utils/localRepresentative/getLocalRepresentative.js